import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import Privacidad from "@/pages/Privacidad";
import Terminos from "@/pages/Terminos";
import EliminacionDatos from "@/pages/EliminacionDatos";

// Component to redirect to static presentation pages
function StaticRedirect({ path }) {
  useEffect(() => {
    window.location.href = `/${path}/index.html`;
  }, [path]);
  return null;
}

// Component to redirect to external URLs (hidden, noindex)
function ExternalRedirect({ url }) {
  useEffect(() => {
    // Add noindex meta tag
    let metaRobots = document.querySelector('meta[name="robots"]');
    if (!metaRobots) {
      metaRobots = document.createElement('meta');
      metaRobots.name = 'robots';
      document.head.appendChild(metaRobots);
    }
    metaRobots.content = 'noindex, nofollow';
    
    // Redirect immediately
    window.location.href = url;
  }, [url]);
  
  return (
    <div style={{ 
      background: '#3f5d6e', 
      color: '#f4f1ef', 
      height: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      fontFamily: 'Helvetica, Arial, sans-serif'
    }}>
      Redirigiendo...
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/privacidad" element={<Privacidad />} />
        <Route path="/terminos" element={<Terminos />} />
        <Route path="/eliminacion-datos" element={<EliminacionDatos />} />
        <Route path="/lascondes125" element={<StaticRedirect path="lascondes125" />} />
        <Route path="/rn40" element={<StaticRedirect path="rn40" />} />
        <Route path="/head2027" element={<StaticRedirect path="head2027" />} />
        <Route path="/galeria" element={<StaticRedirect path="galeria" />} />
        <Route path="/tfm" element={<StaticRedirect path="tfm" />} />
        <Route path="/smarthub" element={<ExternalRedirect url="https://script.google.com/a/macros/agencialabotica.cl/s/AKfycbzlASSlTOoy38cDTh7QCoy6P2n8tg85Zpi0od7j-4A0Al98uvV7VOf_lbHm-Lw364nE/exec" />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
